/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListProfessionalsRequest = {
  properties: {
    search: {
      type: 'string',
      isRequired: true,
    },
    sorting: {
      type: 'Sorting',
      isRequired: true,
    },
    filters: {
      type: 'Filter',
      isRequired: true,
    },
    pagination: {
      type: 'PaginationRequest',
      isRequired: true,
    },
  },
} as const;
